module.exports = __webpack_public_path__ + "img/vyttra_gif_b.51b8eaf4.gif";